
<div class="container fw-b">
  <app-linker-route [headingName]="headingName" [linkerRouteItems]="linkerRouteItems"></app-linker-route>
</div>

<div class="container mb-5 wrapper-content">
  <div class="address-header-row">
    <div class="address-count" *ngIf="listAddressData?.length">
      <span class="address-count-label">Saved addresses</span>
      <span class="address-count-value">{{ listAddressData.length }}</span>
    </div>
    <button
      class="address-add-btn"
      type="button"
      routerLink="/edit-address-customer">
      <img src="assets/latest/plusicon.png" alt="Add new address" class="address-add-icon">
      <span class="address-add-text">Add New Address</span>
    </button>
  </div>

  <div class="address-cards-list">
    <div class="address-card" *ngFor="let item of listAddressData">
      <div class="address-card-main">
        <div class="address-card-left">
          <p class="addressName">{{ item?.firstName }} {{ item?.lastName }}</p>
          <p class="address-line">
            <span class="addressName1">Address:</span><br>
            <span class="text-sty">
              {{ item?.addressLine1 }}<span *ngIf="item?.addressLine2">,</span>
              {{ item?.addressLine2 }}
            </span>
          </p>
          <p class="address-line">
            <span class="text-sty">
              {{ item?.city }}, {{ item?.state }}, {{ item?.country }}
            </span>,
            <span class="text-sty">
              {{ item?.zipCode }}
            </span>
          </p>
          <p class="address-line">
            <span class="text-sty">
              {{ item?.countryCode | phoneFormat }}-{{ item?.mobileNumber | phoneFormat }}
            </span>
        </p>
      </div>
        <div class="address-card-right">
          <div class="address-actions">
            <button
              type="button"
              class="address-action-icon-btn"
              (click)="navigateToEdit(item?._id)"
              aria-label="Edit address">
              <img class="address-action-icon" src="assets/latest/edit1.png" alt="">
            </button>
            <button
              *ngIf="!item?.isPrimary"
              type="button"
              class="address-action-icon-btn"
              (click)="addressModals(item?._id,item?.isPrimary)"
              aria-label="Delete address">
              <img class="address-action-icon" src="assets/latest/delete1.png" alt="">
            </button>
          </div>
          <div class="address-primary-toggle">
            <span class="primary-label" *ngIf="item?.isPrimary">
              <i class="fa fa-check-circle primary-icon" aria-hidden="true"></i>
              Primary
          </span>
            <button
              *ngIf="!item?.isPrimary"
              type="button"
              class="primary-select-btn"
              (click)="toAddressId(item?._id);setPrimaryAddress(item?._id)">
              <i class="fa fa-circle-o" aria-hidden="true"></i>
              Set as Primary
            </button>
        </div>
        </div>
      </div>
    </div>
  </div>

  <div class="address-continue-row">
    <button class="continue-btn" (click)="navigateToOrderOverview()">
      Continue with this address
    </button>
  </div>
</div>

<div class="modal fade" id="addressModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered address-delete-modal" role="document">
    <div class="modal-content ggg address-delete-modal__content">
      <div class="address-delete-modal__icon-wrapper">
        <img
          class="for-img1 address-delete-modal__icon"
          src="assets/latest/logoutui.png"
          alt="Delete address" />
      </div>
      <h2 class="modal-title okay address-delete-modal__title">
        Are you sure you want to delete<br />
        this address?
      </h2>
      <div class="modal-body address-delete-modal__actions">
        <button type="button" class="btn address-delete-btn-secondary" data-dismiss="modal">
          No
        </button>
        <button
          type="button"
          class="btn address-delete-btn-primary"
          data-dismiss="modal"
          (click)="deleteAddress()">
          Yes
        </button>
      </div>
    </div>
  </div>
</div>